<!-- recents jobs -->
<article class="info-card" *ngIf="total$ | async">
  <header>
    <h2 class="info-card__title" i18n="jobs links title">Jobs récents</h2>
  </header>

  <section>
    <app-mini
      *ngFor="let job of ((jobs$ | async) || []).slice(0, 3); trackBy: trackById"
      class="info-card__mini-job"
      [model]="job"
      [queryParams]="jobSearchQueryParams$ | async"
      [bookmark]="(bookmarkMap$ | async)?.get(job.id)"
      [logged]="true"
      (toggleBookmark)="toggleBookmark(job)"
      [trackingData]="{ eventCategory: 'Company Page', eventAction: 'Click See Job', eventLabel: 'Last jobs' }"
    ></app-mini>
  </section>

  <a
    class="info-card__website--jobs"
    [routerLink]="companyJobsPath$ | async"
    [fragment]="CompanyRoutingFragmentEnum.Jobs"
    i18n
    >Voir tous les jobs</a
  >
</article>

<!-- company links -->
<article *ngIf="links$ | async as links" class="info-card">
  <header>
    <h1 class="info-card__title" i18n="social links title">Retrouvez-nous sur</h1>
  </header>

  <section>
    <div class="info-card__links">
      <a
        *ngFor="let link of links; trackBy: trackByLink"
        class="info-card__link"
        [href]="link.url"
        target="_blank"
        rel="nofollow noreferrer noopener"
        [title]="link.title || ''"
      >
        <app-svg-icon [icon]="link.buildIconName(link.type)" width="1.875em"></app-svg-icon>
      </a>
    </div>
  </section>
</article>

<!-- twitter link -->
<article *ngIf="twitterLink$ | async as twitterLink" class="info-card info-card--twitter">
  <a class="twitter-timeline" [href]="twitterLink" data-tweet-limit="1">Tweets by wizbii</a>
</article>
